import {
  LOAN_PURPOSE_OPTIONS,
  LOAN_TERM_OPTIONS,
  LOAN_TYPE_OPTIONS,
  PROPERTY_TYPE_OPTIONS,
  RESIDENCY_TYPE_OPTIONS
} from "../../../../constants"
import { findSelectOptionName } from "../../../../utils"
import SectionCell from "../../cell"

interface Props {
  label:
    | "Loan purpose"
    | "Property type"
    | "Residency type"
    | "Loan type"
    | "Loan term"
    | "Property usage"
  value: number | string
}

const OptionValueToNama = ({ label, value }: Props) => {
  const options = {
    "Loan purpose": LOAN_PURPOSE_OPTIONS,
    "Property type": PROPERTY_TYPE_OPTIONS,
    "Residency type": RESIDENCY_TYPE_OPTIONS,
    "Loan type": LOAN_TYPE_OPTIONS,
    "Loan term": LOAN_TERM_OPTIONS,
    "Property usage": RESIDENCY_TYPE_OPTIONS
  }

  return (
    <SectionCell
      label={label}
      value={findSelectOptionName(value + "", options[label])}
    />
  )
}

export default OptionValueToNama
